import { callApi, getHistoryAccountApi } from '../service/Api';
import { logout } from './auth';
import { history } from '../router/AppRouter';
import { ApiConstants } from '../constants/api';
import { callToast, eraseCookie, getCookie, isApiSuccess } from '../service/Utilities';
import { actionToDo, startSubscription } from './subscription';
import { updateUserPref as updateUserPrefSelect, updateUserPrefMultiple, mapPrefKeyValue, updateUserPrefMultipleByName, getPrefByName } from '../selectors/userPreferences';
// import { actionUpdateEntries } from './subscription';
// import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import * as Sentry from "@sentry/browser";
import Hotjar from '@hotjar/browser';
import { configVarSubsPage } from '../constants/config';
import { COOKIE_NAME } from '../constants/variables';

export const setUserInfo = ({ info = "" } = {}) => ({
    type: 'SET_USER_INFO',
    info
});

export const setSubmodal = (submodal = {}) => {
    return ({
        type: 'SET_SUBMODAL',
        submodal
    });
}

export const startSetUserInfo = () => {
    return (dispatch, getState) => {

        const apiData = {
            url: ApiConstants.USER_INFO,
            token: getState().auth.token,
            data: {
                access_token: getState().auth.token,
                // debug:1
            }
        }

        callApi(apiData)
        .then(res => {
            if(isApiSuccess(res.status)) {
                dispatch(setUserInfo({
                    info: res.info
                }));
                var userID = res.info.user_id || "unknown";
                Sentry.setUser({ 
                    username: userID,
                });
                if(process.env.HOTJAR_ENABLE)
                {
                    if (Hotjar.isReady()) {
                        Hotjar.identify(userID, {
                            product: "FS Beta",
                        });
                    }
                }
                    
                const show_payment_due = res.info.payment_due.modal || false;
                if(!!show_payment_due)
                {
                    dispatch(actionToDo({type:'OPEN_UPDATE_CARD_HOME_MODAL'}))
                }

            }
            else {
                dispatch(logout());
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
        
    };
};

export const setUserPref = ({ pref = "" } = {}) => ({
    type: 'SET_USER_PREF',
    pref
});

export const setAdminSession = (isAdminSession = false) => ({
    type: 'SET_ADMIN_SESSION',
    isAdminSession
});

const handlePrefRedirect = (preferences, path = null) => (dispatch) => {
    const getPref = (key) => getPrefByName(key, preferences, 'value');

    const {
        twcOnReg, isAdmin, isPaidUser, isWizardPending,
        redirectToPricingEnabled, ddUser, team_plan, redirectSpotlight, allowAdminTill,
    } = {
        twcOnReg:                getPref('TRIAL_WITHOUT_CARD_ON_REG') == 2,
        isAdmin:                 getPref('FS_ADMIN') == 2,
        isPaidUser:              !!getPref('PAID_USER'),
        isWizardPending:         getPref('SHOW_WIZARD_RECC_AFTER_UPGRADE') == 1,
        redirectToPricingEnabled:!!getPref('FORCEFULL_REDIRECT_TO_PRICING'),
        ddUser:                  getPref('DD_USER') == 2,
        team_plan:               getPref('FS_TEAMS') == 2,
        redirectSpotlight:       getPref('REDIRECT_SPOTLIGHT'),
        allowAdminTill:          getPref('ALLOW_ADMIN_TILL'),
    };

    const urlPage = window.location.pathname.split('/');
    const fsnewuser = getCookie(COOKIE_NAME.NEW_USER);
    const cookieExists = getCookie(COOKIE_NAME.PLAYLIST);
    const podcastNoRedirect = urlPage.includes('podcast') && cookieExists;
    const ddNoRedirectPages = ['Recommended-Blogs', 'podcast', 'Recommended-Magazines', 'News-Websites', 'spotlight'];
    const ddNoRedirect = ddUser && ddNoRedirectPages.some(page => urlPage.includes(page));
    const noRedirect = ['spotlight', 'settings', configVarSubsPage.SUBS_PAGE_ROUTE, 'podcast', 'teams'];
    const currPage = !urlPage.some(page => noRedirect.includes(page));
    const freeUserRedirect = !twcOnReg && !isPaidUser && !urlPage.some(page => ['settings', 'podcast', 'teams'].includes(page));
    const joinPageSkip = urlPage.includes('teams') && urlPage.includes('join');
    const firstTimeLoginRedirect = fsnewuser && !urlPage.includes('settings');
    const isTypeAdmin = new URLSearchParams(window.location.search).get('type') === 'admin';
    const skipRedirect = isTypeAdmin && allowAdminTill && (Math.floor(Date.now() / 1000) < Number(allowAdminTill));

    if (skipRedirect) dispatch(setAdminSession(true));

    let redirected = false;

    if (team_plan && !joinPageSkip && !urlPage.includes('settings')) {
        history.push('/teams');
        dispatch(manageRouteChange({ route: `${process.env.APP_BASENAME}/teams` }));
        redirected = true;
    } else if (!podcastNoRedirect && !ddNoRedirect && !skipRedirect && !joinPageSkip) {
        if ((firstTimeLoginRedirect || freeUserRedirect) && !isAdmin && redirectToPricingEnabled) {
            if (fsnewuser) eraseCookie(COOKIE_NAME.NEW_USER);
            history.push({ pathname: '/' + configVarSubsPage.SUBS_PAGE_ROUTE, search: window.location.search || "" });
            dispatch(manageRouteChange({ route: `${process.env.APP_BASENAME}/${configVarSubsPage.SUBS_PAGE_ROUTE}` }));
            redirected = true;
        } else if (redirectSpotlight && currPage && !isWizardPending) {
            history.push({ pathname: '/spotlight', search: window.location.search || "" });
            dispatch(manageRouteChange({ route: `${process.env.APP_BASENAME}/spotlight` }));
            redirected = true;
        }
    }

    if (!redirected && path) history.push(path);
};

export const startSetUserPref = (path = null) => {
    return (dispatch, getState) => {
        const apiData = {
            url: ApiConstants.USER_PREF,
            token: getState().auth.token
        }
        callApi(apiData)
        .then(res => {
            if (isApiSuccess(res.status)) {
                // Keys with an unconfirmed optimistic update (see updateUserPrefOptimistic) keep their
                // local value here instead of the fetched one, since this GET can be older than that update
                // (e.g. UPDATE_GENERAL fired by an unrelated action races the wizard's "Done" pref save).
                const localPref = getState().user.pref;
                const mergedPref = res.data.preferences.map(fetched =>
                    isPrefUpdatePending(fetched.name)
                        ? (localPref.find(p => p.name === fetched.name) ?? fetched)
                        : fetched
                );
                dispatch(setUserPref({ pref: mergedPref }));
                dispatch(handlePrefRedirect(mergedPref, path));
                if (getState().main.action_to_do?.type == 'UPDATE_GENERAL') {
                    dispatch(actionToDo({ type: '' }));
                }
            } else {
                if (res.cancelError !== true) dispatch(logout());
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    };
};

export const updateUserPref = (pref = []) => ({
    type: 'UPDATE_USER_PREF',
    pref
});

// Dispatches the Redux pref update immediately, then fires the API call after a 300ms debounce.
// Rapid clicks update Redux (and the UI) on every click but only send one API request after settling.
// _prefApiTimers also doubles as the "pending" set: a key stays in it from the optimistic dispatch
// until its POST settles, so startSetUserPref knows not to overwrite it with stale fetched data.
const _prefApiTimers = {};
const isPrefUpdatePending = (key) => key in _prefApiTimers;
export const updateUserPrefOptimistic = ({ key, value, onSuccess }) => (dispatch, getState) => {
    dispatch(updateUserPref(updateUserPrefSelect({ key, value }, getState().user.pref)));
    clearTimeout(_prefApiTimers[key]);
    _prefApiTimers[key] = setTimeout(() => {
        callApi({
            url: ApiConstants.USER_PREF_UPDATE,
            token: getState().auth.token,
            method: 'POST',
            data: { [key]: value }
        }).then(res => {
            if (onSuccess) {
                const newValue = onSuccess(res);
                if (newValue !== undefined) {
                    dispatch(updateUserPref(updateUserPrefSelect({ key, value: newValue }, getState().user.pref)));
                }
            }
        }).catch(error => console.error('updateUserPrefOptimistic error:', error))
        .finally(() => {
            delete _prefApiTimers[key];
        });
    }, 300);
};

// export const startUpdateUserPref = ({key,value}) => {
    // console.log('startUpdateUserPref',key,value)
    // return (dispatch, getState) => {
export const startUpdateUserPref = ({key,value,showToast=false}) => (dispatch, getState) => new Promise((resolve, reject) => {

        // console.log('start update pref',{key,value})
        const apiData = {
            url: ApiConstants.USER_PREF_UPDATE,
            token: getState().auth.token,
            method: 'POST',
            data: {
                [key]: value
            }
        }

        callApi(apiData)
        .then(res => {
            if(isApiSuccess(res.status)) {
                // console.log('xxx',getState().user.pref)
                // console.log('ttt',key,value)
                dispatch(updateUserPref(updateUserPrefSelect({key,value}, getState().user.pref)));
                if(key=='SORT_FEEDS_FOLDERS' && value==3){
                    // console.log('sort feed folders??')
                    dispatch(startSubscription({sidebarRefresh:true}))
                }
                if(showToast)
                {
                    callToast({type:"success",msg:"Updated Successfully"});
                }
                resolve();
            }
            else {
                if(res.status==425){
                    dispatch(actionToDo({type:"OPEN_RESTRICTION_MODAL",title:res.data?.title,desc:res.data?.desc,isHighest:res?.is_highest_plan},))
                    return;
                }
                if(res.msg) { callToast({type:"error",msg:res.msg}) }
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
        
});

// export const startUpdateUserPrefMultiple = (prefArr = []) => {
    // console.log('startUpdateUserPref',key,value)
    // return (dispatch, getState) => {
export const startUpdateUserPrefMultiple = (prefArr = []) => (dispatch, getState) => new Promise((resolve, reject) => {

        // console.log('prefArr', prefArr)
        // console.log('mapPrefKeyValue', mapPrefKeyValue(prefArr))

        const apiData = {
            url: ApiConstants.USER_PREF_UPDATE,
            token: getState().auth.token,
            method: 'POST',
            data: mapPrefKeyValue(prefArr)
        }

        callApi(apiData)
        .then(res => {
            if(isApiSuccess(res.status)) {
                // console.log('selector', updateUserPrefMultiple(prefArr, getState().user.pref));
                dispatch(updateUserPref(updateUserPrefMultiple(prefArr, getState().user.pref)));
                resolve();
            }
            else {
                if(res.status==425){
                    dispatch(actionToDo({type:"OPEN_RESTRICTION_MODAL",title:res.data?.title,desc:res.data?.desc,isHighest:res?.is_highest_plan},))
                    return;
                }
                if(res.msg) { callToast({type:"error",msg:res.msg}) }
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
        
});

export const startUpdateProfileApi = (profileData) => (dispatch, getState) => new Promise((resolve, reject) => {

    const apiData = {
        url: ApiConstants.UPDATE_PROFILE,
        token: getState().auth.token,
        method: 'POST',
        isFormdata: true,
        files: ['image'],
        // data: { name, website,blog, youtube_channel, bio, image, new_password}
        data: { ...profileData }
    }

    callApi(apiData)
    .then(res => {
        if(isApiSuccess(res.status)) {
            // let prefArr = [];
            if(!!res.data.user_pref && res.data.user_pref.length>0) {
                // for (const [key, value] of res.data) {
                //     prefArr.push({key,value});
                // }
                dispatch(updateUserPref(updateUserPrefMultiple(res.data.user_pref, getState().user.pref)));
            }
            if(!!res.data.user_info) {
                dispatch(setUserInfo({
                    info: {
                        ...getState().user.info,
                        ...res.data.user_info
                    }
                }));
            }
            callToast({type:"success",msg:"Saved Successfully"});
            resolve();
        }
        else {
            if(res.msg) { callToast({type:"error",msg:res.msg}) }
        }
    })
    
});

export const startVerifyEmailApi = ({otp, email}) => (dispatch, getState) => new Promise((resolve, reject) => {

    const apiData = {
        url: ApiConstants.VERIFY_EMAIL,
        token: getState().auth.token,
        method: 'POST',
        data: { otp, email }
    }

    callApi(apiData)
    .then(res => {
        if(isApiSuccess(res.status)) {
            if(!!res.data.userinfo) {
                dispatch(setUserInfo({
                    info: {
                        ...getState().user.info,
                        ...res.data.userinfo
                    }
                }));
            }
            callToast({type:"success",msg:"Updated Successfully"});
            resolve(res.data);
        }
        else {
            if(res.msg) { callToast({type:"error",msg:res.msg}) }
        }
    })
    
});

export const manageRouteChange = ({route}) => (dispatch, getState) => new Promise((resolve, reject) => {
    let newRoute = '/'+route;
    if(window.location.pathname != newRoute)
    {
        // console.log('manageRouteChange newRoute',newRoute)
    //   window.history.replaceState(null, null, newRoute);
      setTimeout(() => {
        if(window.location.pathname != newRoute)
        {
            // console.log('xxx', newRoute.split('/'))

            // console.log('yy',newRoute.split('/').slice(2).join('/'));
            // let x = newRoute.split('/').includes(process.env.APP_BASENAME)?newRoute.split('/').slice(2).join('/'):newRoute;
            window.history.replaceState(null, null, newRoute);
            // history.push(x);
        }
      }, 100);
      // ReactGA.pageview(window.location.pathname + window.location.search)
    //   ReactGA.pageview(newRoute);

    // console.log('pageview', { hitType: "pageview", newRoute })
      ReactGA.send({ hitType: "pageview", page: newRoute });
      getHistoryAccountApi({url:newRoute, token:getState().auth.token});
    //   .then((res) => {
    //     if(isApiSuccess(res.status)) {
    //       resolve(res.data);
    //     }
    //     else {
    //         if(res.msg) { callToast({type:"error",msg:res.msg}) }
    //     }
    //   });
    }
  });

export const startUpdatePassword = ({password}) => (dispatch, getState) => new Promise((resolve, reject) => {

    const apiData = {
        url: ApiConstants.UPDATE_PASSWORD,
        token: getState().auth.token,
        method: 'POST',
        data: {
            new_password:password
        }
    }
    callApi(apiData)
    .then(res => {
        if(isApiSuccess(res.status)) {
            const { preferences=[] } = res.data;
            if(preferences.length>0){
                dispatch(updateUserPref(updateUserPrefMultipleByName(preferences, getState().user.pref)));
            }
            resolve(res);
        }
        else {
            if(res.msg) { callToast({type:"error",msg:res.msg}) }
        }
    })
    
});

export const startSubmitFeedback = ({rating,message}) => (dispatch, getState) => new Promise((resolve, reject) => {

    const apiData = {
        url: ApiConstants.FEEDBACK,
        token: getState().auth.token,
        method: 'POST',
        data: {
            rating,
            message
        }
    }
    callApi(apiData)
    .then(res => {
        if(isApiSuccess(res.status)) {
            const { preferences=[] } = res.data;
            if(preferences.length>0){
                dispatch(updateUserPref(updateUserPrefMultipleByName(preferences, getState().user.pref)));
            }
            callToast({type:"success",msg:"Feedback submitted successfully."})
            resolve(res.data);
        }
        else {
            if(res.msg) { callToast({type:"error",msg:res.msg}) }
        }
    })
    
});


export const incrementModalRound = (round) => (dispatch,getState) => new Promise((resolve,reject) => {
    const apiData = {
        url:ApiConstants.PRICING_MODAL_INTERVAL,
        token:getState().auth.token,
        method:'POST',
        data:{
            round
        }
    }
    callApi(apiData)
    .then(res => {
        if(isApiSuccess(res.status)){
            dispatch(startSetUserPref());
        }else{
            console.error(res.msg)
        }
    })
    .catch((error) => {
        console.error(error);
    })
})